import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TFileItem } from '../types/upload-file.type';

export const UploadFileValidationSchema = z.object({
  files: z.array(z.instanceof(File, { message: 'Please select valid files to upload' })),
});

export type TUploadFileValidation = z.infer<typeof UploadFileValidationSchema>;
export type TUploadFilePayload = TUploadFileValidation;
export type TUploadFileResponse = ApiResponse<{ files: TFileItem[] }>;

export const uploadFile = async (payload: TUploadFilePayload): Promise<TUploadFileResponse> => {
  const url = '/file/upload';

  const formData = new FormData();

  payload.files.forEach((file) => {
    formData.append('files', file);
  });

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return axiosInstance.post(url, formData, config);
};

/**
 * Use Create Label Ticketing React-Query Hook
 */
type UseUploadFileMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof uploadFile, AxiosErrorCustom>;
};

/**
 * Use Create Label Ticketing React-Query Hook
 */
export const useUploadFileMutation = ({ mutationConfig }: UseUploadFileMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: uploadFile,
    ...restConfig,
  });
};
